if (!customElements.get('price-plan-selector')) {
  const D3_BUNDLE_SELLING_PLAN = '692138180935';
  const OMEGA_PAID_GIFT_BY_PACK = {
    1: { id: '54771992822087', sellingPlan: '692138213703' },
    3: { id: '54771992854855', sellingPlan: '692138246471' },
    6: { id: '54771992887623', sellingPlan: '692138279239' },
  };
  const OMEGA_KWFM_GIFT_BY_PACK = OMEGA_PAID_GIFT_BY_PACK;
  const OMEGA_PHASEN_GIFT_BY_PACK = {
    1: { id: '54771992822087', sellingPlan: '692138082631' },
    3: { id: '54771992854855', sellingPlan: '692138115399' },
    6: { id: '54771992887623', sellingPlan: '692138148167' },
  };
  const OMEGA_FREE_MAIN_PLAN_IDS = new Set([
    '692138082631',
    '692138115399',
    '692138148167',
    '692138180935',
  ]);
  const OMEGA_PHASEN_FREE_BY_PACK = {
    1: { id: '54771992822087', sellingPlan: '692138082631' },
    3: { id: '54771992854855', sellingPlan: '692138115399' },
    6: { id: '54771992887623', sellingPlan: '692138148167' },
  };
  const STANDALONE_MAIN_PRODUCT_HANDLES = new Set(['omega-3', 'vitamin-d3-k2-oel']);
  const OMEGA_PHASEN_PRODUCT_HANDLES = new Set([
    'kinderwunsch-frau',
    'kinderwunsch-mann',
    'schwangerschaft',
    'stillzeit',
  ]);
  const KWFM_FRAU_MANN_PRODUCT_HANDLES = new Set(['kinderwunsch-bundle']);
  const KWFM_FRAU_MANN_OMEGA_BY_PACK = {
    1: { id: '54870157623623', sellingPlan: '692138213703' },
    3: { id: '54870157656391', sellingPlan: '692138246471' },
    6: { id: '54870157689159', sellingPlan: '692138279239' },
  };
  const KWFM_FRAU_MANN_D3_SELLING_PLAN = '692139295047';
  const KWFM_FRAU_MANN_D3_VARIANT_ID = '54870216343879';
  const KWFM_FRAU_MANN_D3_BY_PACK = {
    1: { id: KWFM_FRAU_MANN_D3_VARIANT_ID, sellingPlan: KWFM_FRAU_MANN_D3_SELLING_PLAN },
    3: { id: KWFM_FRAU_MANN_D3_VARIANT_ID, sellingPlan: KWFM_FRAU_MANN_D3_SELLING_PLAN },
    6: { id: KWFM_FRAU_MANN_D3_VARIANT_ID, sellingPlan: KWFM_FRAU_MANN_D3_SELLING_PLAN },
  };
  const LEGACY_OMEGA_VARIANT_IDS = new Set([
    '54771992822087',
    '54771992854855',
    '54771992887623',
    '54831471853895',
  ]);
  const LEGACY_D3_VARIANT_IDS = new Set([
    '54846083170631',
    '54846083203399',
    '54846083236167',
    '54831336030535',
    '54831336063303',
  ]);
  const KINDERWUNSCH_BUNDLE_GIFT_MULTIPLIER = 2;
  const KINDERWUNSCH_BUNDLE_MAIN_PLANS = new Set([
    '692130742599',
    '692130775367',
    '692130808135',
  ]);

  customElements.define(
    'price-plan-selector',
    class PricePlanSelector extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.mode = this.dataset.mode || 'sub';
        this.servings = parseInt(this.dataset.servings, 10) || 30;
        this.sectionId = this.dataset.section;
        this.strings = this.readStrings();
        this.kwfmCartConfig = this.readKwfmCartConfig();
        this.moneySample = this.dataset.moneySample || window.themeMoney?.sample || '';
        this.currencyIso = this.dataset.currency || window.themeMoney?.iso || '';
        this.currencySymbol = this.dataset.currencySymbol || window.themeMoney?.symbol || '';
        this.addonState = {};

        this.packs = Array.from(this.querySelectorAll('.price-plan__pack'));
        this.subOption = this.querySelector('.price-plan__option--sub');
        this.onceOption = this.querySelector('.price-plan__option--once');
        this.modeInputs = Array.from(this.querySelectorAll('.price-plan__mode-input'));
        this.addons = Array.from(this.querySelectorAll('[data-addon]'));
        this.gifts = Array.from(this.querySelectorAll('[data-gift]'));
        this.frequencySelect = this.querySelector('[data-frequency-select]');
        this.mode = this.querySelector('.price-plan__mode-input:checked')?.value || 'sub';
        this.variantBenefits = this.readVariantBenefits();

        this.bindEvents();
        this.bindVariantChange();
        this.whenReady(() => this.sync());
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber?.();
      }

      readVariantBenefits() {
        const node = this.querySelector('[data-variant-benefits]');
        try {
          return JSON.parse(node?.textContent || '{}');
        } catch (error) {
          return {};
        }
      }

      refreshVariantBenefitsFromHtml(html) {
        const root = html?.querySelector?.(`price-plan-selector[data-section="${this.sectionId}"]`);
        const node = root?.querySelector('[data-variant-benefits]');
        if (!node) return;
        try {
          this.variantBenefits = JSON.parse(node.textContent || '{}');
        } catch (error) {
          /* keep existing map */
        }
      }

      bindVariantChange() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

        this.onVariantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event?.data?.sectionId !== this.sectionId) return;

          if (event.data?.html) {
            this.refreshVariantBenefitsFromHtml(event.data.html);
          }

          const variantId = String(event.data?.variant?.id || '');
          if (!variantId) return;

          let matchingPack = this.packs.find(
            (pack) => pack.dataset.variantId === variantId || pack.dataset.benefitVariantId === variantId
          );

          if (!matchingPack && event.data?.variant) {
            const variant = event.data.variant;
            const packCount =
              parseInt(variant.metafields?.pack_count, 10) ||
              parseInt(String(variant.option1 || variant.title || '').split(' ')[0], 10) ||
              0;
            if (packCount > 0) {
              matchingPack = this.packs.find((pack) => parseInt(pack.dataset.packCount, 10) === packCount);
            }
          }

          if (matchingPack && !matchingPack.classList.contains('is-selected')) {
            this.selectPack(matchingPack);
            return;
          }

          if (this.frequencySelect) {
            const matchingOption = Array.from(this.frequencySelect.options).find(
              (option) => option.dataset.variantId === variantId || option.dataset.benefitVariantId === variantId
            );
            if (matchingOption && matchingOption !== this.frequencySelect.selectedOptions[0]) {
              this.frequencySelect.value = matchingOption.value;
              this.selectFrequency();
              return;
            }
          }

          this.sync();
        });
      }

      whenReady(callback) {
        const run = () => callback();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', run, { once: true });
        } else {
          run();
        }
      }

      readKwfmCartConfig() {
        const node = this.querySelector('[data-kwfm-frau-mann-cart]');
        if (!node) return null;
        try {
          return JSON.parse(node.textContent || 'null');
        } catch (error) {
          return null;
        }
      }

      readStrings() {
        const node = this.querySelector('[data-price-plan-strings]');
        try {
          return JSON.parse(node?.textContent || '{}');
        } catch (error) {
          return {};
        }
      }

      bindEvents() {
        this.packs.forEach((pack) => {
          pack.addEventListener('click', () => {
            if (pack.disabled) return;
            this.selectPack(pack);
          });
        });

        this.modeInputs.forEach((input) => {
          input.addEventListener('change', () => {
            this.mode = input.value;
            this.sync();
          });
        });

        this.addons.forEach((addon) => {
          addon.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            const onceInput = this.querySelector('.price-plan__mode-input[value="once"]');
            if (onceInput) {
              onceInput.checked = true;
              this.mode = 'once';
            }
            this.toggleAddon(addon);
          });
        });

        this.frequencySelect?.addEventListener('click', (event) => event.stopPropagation());
        this.frequencySelect?.addEventListener('mousedown', (event) => event.stopPropagation());
        this.frequencySelect?.addEventListener('change', () => this.selectFrequency());
        this.selectFrequency(true);
      }

      selectedPack() {
        return this.querySelector('.price-plan__pack.is-selected') || this.packs[0] || this;
      }

      packData(pack) {
        const source = pack || this;
        const data = {
          id: source.dataset.variantId || this.dataset.selectedId,
          packCount: parseInt(source.dataset.packCount, 10) || 1,
          price: parseInt(source.dataset.packPrice || source.dataset.price, 10) || 0,
          variantPrice: parseInt(source.dataset.variantPrice || source.dataset.packPrice || source.dataset.price, 10) || 0,
          subPrice: parseInt(source.dataset.packSubPrice || source.dataset.subPrice, 10) || 0,
          comparePrice: parseInt(source.dataset.packComparePrice || source.dataset.comparePrice, 10) || 0,
          discountType: (source.dataset.discountType || this.dataset.discountType || '').toLowerCase(),
          discountValue: parseFloat(source.dataset.discountValue || this.dataset.discountValue || '0') || 0,
          sellingPlan: source.dataset.sellingPlan || this.dataset.sellingPlan || '',
          available: source.dataset.available !== 'false',
          mediaId: source.dataset.mediaId || '',
          packImage: source.dataset.packImage || '',
          packAspectRatio: parseFloat(source.dataset.packAspectRatio) || 1.333,
        };

        if (this.isStandaloneMainProduct()) {
          data.sellingPlan = this.sanitizeMainSellingPlan(data.sellingPlan, data);
        }

        return data;
      }

      subscriptionPrice(pack) {
        const list = pack.price || 0;
        const type = pack.discountType;
        const value = pack.discountValue;
        if (type === 'price' && value > 0) return Math.round(value);
        if (type === 'percentage') {
          return Math.max(Math.round((list * (100 - value)) / 100), 0);
        }
        if (type === 'fixed_amount') return Math.max(Math.round(list - value), 0);
        return pack.subPrice || list;
      }

      selectPack(pack) {
        this.packs.forEach((item) => {
          const selected = item === pack;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-checked', selected ? 'true' : 'false');
        });
        if (pack.dataset.sellingPlan !== undefined) {
          const packInfo = this.packData(pack);
          this.dataset.sellingPlan = this.isSubMode() ? packInfo.sellingPlan || '' : '';
        }
        if (pack.dataset.discountType) this.dataset.discountType = pack.dataset.discountType;
        if (pack.dataset.discountValue) this.dataset.discountValue = pack.dataset.discountValue;
        if (pack.dataset.variantId) this.dataset.selectedId = pack.dataset.variantId;
        if (pack.dataset.packCount) this.dataset.packCount = pack.dataset.packCount;
        this.sync();
      }

      selectFrequency(silent = false) {
        const option = this.frequencySelect?.selectedOptions?.[0];
        if (!option) return;
        const freqPack = {
          sellingPlan: option.dataset.sellingPlan || option.value || '',
          discountType: (option.dataset.discountType || '').toLowerCase(),
          discountValue: parseFloat(option.dataset.discountValue || '0') || 0,
          price: parseInt(option.dataset.packPrice, 10) || 0,
          subPrice: parseInt(option.dataset.packSubPrice, 10) || 0,
        };
        this.dataset.sellingPlan = this.sanitizeMainSellingPlan(freqPack.sellingPlan, freqPack);
        this.dataset.packCount = option.dataset.packCount || this.dataset.packCount || '1';
        if (option.dataset.packPrice) this.dataset.price = option.dataset.packPrice;
        if (option.dataset.packSubPrice) this.dataset.subPrice = option.dataset.packSubPrice;
        if (option.dataset.packComparePrice) this.dataset.comparePrice = option.dataset.packComparePrice;
        if (option.dataset.discountType) this.dataset.discountType = option.dataset.discountType;
        if (option.dataset.discountValue) this.dataset.discountValue = option.dataset.discountValue;
        if (option.dataset.variantId) {
          this.dataset.selectedId = option.dataset.variantId;
          this.dataset.variantId = option.dataset.variantId;
        }
        if (!silent) this.sync();
      }

      setMode(mode) {
        this.mode = mode;
        const input = this.querySelector(`.price-plan__mode-input[value="${mode}"]`);
        if (input) input.checked = true;
        this.sync();
      }

      toggleAddon(addon) {
        const id = addon.dataset.variantId;
        this.addonState[id] = !this.addonState[id];
        addon.classList.toggle('is-selected', this.addonState[id]);
        addon.setAttribute('aria-pressed', this.addonState[id] ? 'true' : 'false');
        this.sync();
      }

      moneyTokens(cents) {
        const abs = Math.abs(Math.round(Number(cents) || 0));
        const [wholeRaw, dec] = (abs / 100).toFixed(2).split('.');
        const whole = String(parseInt(wholeRaw, 10));
        const groupedComma = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        const groupedDot = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        const groupedSpace = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        const groupedNbsp = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0');
        return [
          `${groupedDot},${dec}`,
          `${groupedComma}.${dec}`,
          `${groupedSpace},${dec}`,
          `${groupedNbsp},${dec}`,
          `${whole},${dec}`,
          `${whole}.${dec}`,
        ];
      }

      formatMoney(cents) {
        const value = Math.round(Number(cents) || 0);
        const sample = this.moneySample || window.themeMoney?.sample || '';
        if (sample) {
          const sampleTokens = this.moneyTokens(window.themeMoney?.sampleCents || 123456);
          const valueTokens = this.moneyTokens(value);
          for (let i = 0; i < sampleTokens.length; i++) {
            if (sample.indexOf(sampleTokens[i]) !== -1) {
              return sample.split(sampleTokens[i]).join(valueTokens[i]);
            }
          }
        }
        if (window.Shopify?.formatMoney && window.Money_Filter && String(window.Money_Filter).indexOf('{{') !== -1) {
          return Shopify.formatMoney(value, window.Money_Filter);
        }
        if (this.currencyIso) {
          try {
            return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
              style: 'currency',
              currency: this.currencyIso,
            }).format(value / 100);
          } catch (error) {
            // Fall through to symbol formatting
          }
        }
        const symbol = this.currencySymbol || '€';
        return `${(value / 100).toFixed(2).replace('.', ',')} ${symbol}`;
      }

      formatPerDay(cents, packCount, asBenefit = false) {
        const days = this.perDayDivisor(packCount);
        if (!days) return '';
        const formatted = this.formatMoney(Math.round(cents / days));
        const template = asBenefit ? this.strings.perDayBenefit : this.strings.perDay;
        return (template || '__AMOUNT__ / Tag').replace('__AMOUNT__', formatted);
      }

      perDayBenefitAmount(cents, packCount) {
        const days = this.perDayDivisor(packCount);
        if (!days) return '';
        return this.formatMoney(Math.round(cents / days));
      }

      applyBenefitTemplate(template, cents, packCount) {
        const amount = this.perDayBenefitAmount(cents, packCount);
        return String(template || '')
          .replace(/__AMOUNT__/g, amount)
          .replace(/\{\{\s*amount\s*\}\}/gi, amount);
      }

      parseBenefitsPayload(raw) {
        if (!raw) return null;
        try {
          return JSON.parse(raw);
        } catch (error) {
          return null;
        }
      }

      benefitSourceElement() {
        if (this.dataset.layout === 'classic') {
          return this.frequencySelect?.selectedOptions?.[0] || null;
        }
        return this.selectedPack();
      }

      benefitVariantId(source) {
        const element = source || this.benefitSourceElement();
        if (element?.dataset?.benefitVariantId) return String(element.dataset.benefitVariantId);
        if (element?.dataset?.variantId) return String(element.dataset.variantId);
        return String(this.activePackData()?.id || '');
      }

      benefitPackCount(source) {
        const element = source || this.benefitSourceElement();
        const fromElement = parseInt(element?.dataset?.packCount, 10);
        if (fromElement > 0) return String(fromElement);
        return String(Math.max(this.activePackData()?.packCount || 1, 1));
      }

      resolveBenefitConfig(source) {
        const element = source || this.benefitSourceElement();
        const inline = this.parseBenefitsPayload(element?.dataset?.benefits);
        if (inline) return inline;

        const variantId = this.benefitVariantId(element);
        const packCount = this.benefitPackCount(element);
        const map = this.variantBenefits || {};

        if (variantId && map.variants?.[variantId]) {
          return map.variants[variantId];
        }
        if (packCount && map.byPackCount?.[packCount]) {
          return map.byPackCount[packCount];
        }
        if (variantId && map[variantId]) {
          return map[variantId];
        }

        const ds = element?.dataset || {};
        if (ds.benefit1Dynamic !== undefined || ds.benefit2Text !== undefined || ds.benefit3Dynamic !== undefined) {
          return {
            benefit1Dynamic: ds.benefit1Dynamic === 'true',
            benefit1Template: ds.benefit1Template || '',
            benefit2Text: ds.benefit2Text || '',
            benefit3Dynamic: ds.benefit3Dynamic === 'true',
            benefit3Text: ds.benefit3Text || '',
          };
        }

        return {
          benefit1Dynamic: this.dataset.benefit1Dynamic === 'true',
          benefit1Template: this.dataset.benefit1Template || '',
          benefit2Text: '',
          benefit3Dynamic: this.dataset.benefit3Dynamic === 'true',
          benefit3Text: this.dataset.benefit3Text || '',
        };
      }

      updateSubscriptionBenefits(source, pack, subPrice) {
        const config = this.resolveBenefitConfig(source);
        if (!config) return;

        const benefit1Dynamic = config.benefit1Dynamic === true || config.benefit1Dynamic === 'true';
        const benefit1Template = config.benefit1Template || '';
        const benefit2Text = config.benefit2Text || '';
        const benefit3Dynamic = config.benefit3Dynamic === true || config.benefit3Dynamic === 'true';
        const benefit3Text = config.benefit3Text || '';
        const packCount = pack?.packCount || 1;

        this.dataset.benefit1Dynamic = benefit1Dynamic ? 'true' : 'false';
        if (benefit1Dynamic) {
          delete this.dataset.benefit1Template;
        } else if (benefit1Template) {
          this.dataset.benefit1Template = benefit1Template;
        } else {
          delete this.dataset.benefit1Template;
        }

        this.dataset.benefit3Dynamic = benefit3Dynamic ? 'true' : 'false';
        if (benefit3Dynamic) {
          delete this.dataset.benefit3Text;
        } else if (benefit3Text) {
          this.dataset.benefit3Text = benefit3Text;
        } else {
          delete this.dataset.benefit3Text;
        }

        const benefitsRoot = this.subOption?.querySelector('.price-plan__benefits') || this.querySelector('.price-plan__benefits');
        const perDayBenefit = benefitsRoot?.querySelector('[data-benefit="per-day"]');
        const customBenefit = benefitsRoot?.querySelector('[data-benefit="custom"]');
        const cancelBenefit = benefitsRoot?.querySelector('[data-benefit="cancel"]');

        const showBenefit1 = benefit1Dynamic || Boolean(benefit1Template);
        if (perDayBenefit) {
          perDayBenefit.hidden = !showBenefit1;
          if (showBenefit1) {
            if (benefit1Dynamic) {
              perDayBenefit.textContent = this.formatPerDay(subPrice, packCount, true);
            } else {
              perDayBenefit.textContent = this.applyBenefitTemplate(benefit1Template, subPrice, packCount);
            }
          }
        }

        if (customBenefit) {
          customBenefit.textContent = benefit2Text;
          customBenefit.hidden = !benefit2Text;
        }

        const showBenefit3 = benefit3Dynamic || Boolean(benefit3Text);
        if (cancelBenefit) {
          cancelBenefit.hidden = !showBenefit3;
          if (showBenefit3) {
            if (benefit3Dynamic) {
              cancelBenefit.textContent =
                packCount === 1 ? this.strings.deliveryStart || '' : this.strings.cancellable || '';
            } else {
              cancelBenefit.textContent = benefit3Text;
            }
          }
        }
      }

      perDayDivisor(packCount) {
        const months = Math.max(parseInt(packCount, 10) || 1, 1);
        const pouches = months * this.perDayPouchMultiplier();
        return pouches * this.servings;
      }

      perDayPouchMultiplier() {
        const fromData = parseInt(this.dataset.perDayPouchMultiplier, 10);
        if (fromData > 0) return fromData;
        if (this.isKinderwunschFrauMann() || this.isKinderwunschBundle()) {
          return KINDERWUNSCH_BUNDLE_GIFT_MULTIPLIER;
        }
        return 1;
      }

      mainQuantity() {
        const root = this.closest('product-info') || document;
        const input = root.querySelector('input[name="quantity"]');
        return Math.max(parseInt(input?.value, 10) || 1, 1);
      }

      addonQty(addon) {
        if (!this.addonState[addon.dataset.variantId]) return 0;
        return this.mainQuantity();
      }

      addonSum() {
        const packCount = this.getSelectedPackCount();
        const months = Math.max(packCount, 1);

        return this.addons.reduce((sum, addon) => {
          if (!this.addonQty(addon)) return sum;

          const variantData = this.parseVariantMap(addon);
          const entry = this.variantEntry(variantData, packCount);
          const price = parseInt(entry?.price || addon.dataset.price, 10) || 0;
          let lineQty = this.mainQuantity();

          if (this.isOmegaAddon(addon) && this.isPhasenBundle()) {
            lineQty = 1;
          } else if (addon.dataset.qtyMode === 'pack') {
            lineQty = months * lineQty;
          }

          return sum + price * lineQty;
        }, 0);
      }

      updateAddonCopy(addon, packCount) {
        const selected = !!this.addonState[addon.dataset.variantId];
        const variantData = this.parseVariantMap(addon);
        const entry = this.variantEntry(variantData, packCount);
        const price = parseInt(entry?.price || addon.dataset.price, 10) || 0;
        const qty = selected ? this.mainQuantity() : 0;
        const unit = addon.dataset.unitPrice;
        const note = addon.dataset.note;
        const priceEl = addon.querySelector('[data-addon-price]');
        const nameEl = addon.querySelector('[data-addon-name]');
        const baseName = addon.dataset.name || nameEl?.textContent || '';

        this.updateItemImage(addon, '[data-addon-image]', variantData, packCount);
        if (!priceEl) return;

        let text = '';
        const months = Math.max(packCount, 1);
        const monthsNote = this.isMonthsNote(note, addon.dataset.noteMode);

        if (this.isKwfmOmegaAddon(addon)) {
          const displayCount = this.bundleOmegaAddonPortionsCount(packCount);
          const portions = this.portionsText(displayCount);
          const displayValue = this.kwfmOmegaBundleValuePrice(price);
          const valueLine = (this.strings.giftValuePortions || 'Wert __AMOUNT__ · __PORTIONS__')
            .replace('__AMOUNT__', this.formatMoney(displayValue))
            .replace('__PORTIONS__', portions);

          if (nameEl) {
            nameEl.textContent = this.formatManyProductName(displayCount, baseName);
          }

          if (selected) {
            text = `+ ${this.formatMoney(price)} · ${portions}`;
          } else {
            text = valueLine;
          }
          priceEl.textContent = text;
          return;
        }

        if (this.isPhasenOmegaAddon(addon)) {
          const displayCount = this.phasenOmegaDisplayCount(packCount);
          const portions = this.portionsText(displayCount);
          const valueLine = (this.strings.giftValuePortions || 'Wert __AMOUNT__ · __PORTIONS__')
            .replace('__AMOUNT__', this.formatMoney(price))
            .replace('__PORTIONS__', portions);

          if (nameEl) {
            nameEl.textContent =
              displayCount > 1
                ? this.formatManyProductName(displayCount, baseName)
                : baseName;
          }

          if (selected) {
            text = `+ ${this.formatMoney(price)} · ${portions}`;
          } else {
            text = valueLine;
          }
          priceEl.textContent = text;
          return;
        }

        if (this.isKwfmD3Addon(addon)) {
          const duration = this.durationNote(addon, note);
          const valueLine = (this.strings.giftValuePortions || 'Wert __AMOUNT__ · __PORTIONS__')
            .replace('__AMOUNT__', this.formatMoney(price))
            .replace('__PORTIONS__', duration);

          if (nameEl) {
            nameEl.textContent = this.kwfmD3DisplayName(baseName);
          }

          if (selected) {
            text = `+ ${this.formatMoney(price)} · ${duration}`;
          } else {
            text = valueLine;
          }
          priceEl.textContent = text;
          return;
        }

        if (nameEl && baseName) {
          nameEl.textContent = baseName;
        }

        if (monthsNote) {
          text = selected ? `+ ${this.formatMoney(price * Math.max(qty, 1))}` : this.formatMoney(price);
          if (unit) text += ` (${unit})`;
          text += ` · ${this.durationNote(addon, note)}`;
        } else {
          const portions = this.portionsText(months);
          const lineQty =
            this.isOmegaAddon(addon) && this.isPhasenBundle()
              ? 1
              : addon.dataset.qtyMode === 'pack'
                ? months
                : selected
                  ? qty
                  : 1;
          if (selected) {
            text = `+ ${this.formatMoney(price * lineQty)} · ${portions}`;
          } else {
            text = this.formatMoney(price);
            if (months > 1) text += ` ${this.strings.perTin || 'pro Dose'} · ${portions}`;
            else text += ` · ${portions}`;
          }
        }
        priceEl.textContent = text;
      }

      sync() {
        const pack = this.activePackData();
        const subSelected = this.getActiveMode() === 'sub';
        const subPrice = this.subscriptionPrice(pack);
        const oncePrice = pack.price || 0;
        const refPrice = Math.max(pack.comparePrice || 0, oncePrice);
        const onceTotal = oncePrice + this.addonSum();
        const save = Math.max(refPrice - subPrice, 0);

        this.updateSubscriptionBenefits(this.benefitSourceElement(), pack, subPrice);

        this.subOption?.classList.toggle('is-selected', subSelected);
        this.onceOption?.classList.toggle('is-selected', !subSelected);

        const subPriceEl = this.querySelector('.price-plan__option-price[data-sub-price]');
        if (subPriceEl) subPriceEl.textContent = this.formatMoney(subPrice);
        const compareEl = this.querySelector('[data-ref-price]');
        if (compareEl) {
          compareEl.hidden = save <= 0;
          compareEl.textContent = this.formatMoney(refPrice);
        }
        const oncePriceEl = this.querySelector('.price-plan__option-price[data-once-price]');
        if (oncePriceEl) oncePriceEl.textContent = this.formatMoney(onceTotal);

        const saveBadge = this.querySelector('[data-save-badge]');
        if (saveBadge) {
          saveBadge.hidden = save <= 0;
          saveBadge.textContent = (this.strings.save || 'Spare __AMOUNT__').replace(
            '__AMOUNT__',
            this.formatMoney(save)
          );
        }

        const delivery = this.querySelector('[data-delivery-text]');
        if (delivery) {
          delivery.textContent =
            pack.packCount === 1
              ? this.strings.deliveryStart || ''
              : (this.strings.delivery || '').replace('__COUNT__', String(pack.packCount));
        }

        const savePercentEl = this.querySelector('[data-benefit="save-percent"]');
        if (savePercentEl) {
          const percent = refPrice > 0 ? Math.round((save / refPrice) * 100) : 0;
          savePercentEl.textContent = (this.strings.classicSave || 'Dauerhaft __PERCENT__ % sparen').replace(
            '__PERCENT__',
            String(percent)
          );
        }

        this.packs.forEach((item) => {
          const data = this.packData(item);
          const price = subSelected ? this.subscriptionPrice(data) : data.price;
          const perDay = item.querySelector('[data-pack-perday]');
          if (perDay) perDay.textContent = this.formatPerDay(price, data.packCount);
        });

        this.gifts.forEach((gift) => this.updateGiftCopy(gift, pack.packCount));
        this.addons.forEach((addon) => this.updateAddonCopy(addon, pack.packCount));
        this.syncForms(pack, subSelected);
      }

      formRoots() {
        return [
          this.closest('product-info'),
          document.querySelector('.sticky-add-to-cart__wrapper'),
        ].filter(Boolean);
      }

      syncForms(pack, subSelected) {
        const cartItem = this.getMainCartItem();
        const knownIds = new Set(
          [
            this.dataset.variantId,
            this.dataset.unitVariantId,
            this.dataset.onceVariantId,
            cartItem.id,
            ...this.packs.map((item) => item.dataset.variantId),
          ].filter(Boolean)
        );
        if (this.frequencySelect) {
          Array.from(this.frequencySelect.options).forEach((option) => {
            if (option.dataset?.variantId) knownIds.add(String(option.dataset.variantId));
          });
        }

        this.formRoots().forEach((root) => {
          root.querySelectorAll('input.product-variant-id').forEach((input) => {
            const shouldUpdate =
              this.dataset.layout === 'classic' || knownIds.has(String(input.value));
            if (!shouldUpdate) return;
            input.value = cartItem.id || pack.id || '';
            input.disabled = !pack.available;
          });
          root.querySelectorAll('input.selling_plan').forEach((input) => {
            const variantInput = input.form?.querySelector('input.product-variant-id');
            if (variantInput && !knownIds.has(String(variantInput.value)) && String(variantInput.value) !== String(cartItem.id)) {
              return;
            }
            if (subSelected && cartItem.sellingPlan) {
              input.setAttribute('name', 'selling_plan');
              input.value = cartItem.sellingPlan;
            } else {
              input.removeAttribute('name');
              input.value = '';
            }
          });
        });

        const productInfo = this.closest('product-info');
        const url = productInfo?.dataset.url;
        const activeVariantId = cartItem.id || pack.id;
        if (url && activeVariantId && productInfo?.dataset.updateUrl !== 'false') {
          try {
            const next = new URL(url, window.location.origin);
            next.searchParams.set('variant', activeVariantId);
            const nextPath = `${next.pathname}${next.search}`;
            if (`${window.location.pathname}${window.location.search}` !== nextPath) {
              window.history.replaceState({}, '', nextPath);
            }
          } catch (error) {
            // Ignore malformed product URLs
          }
        }
      }

      unitPack() {
        return this.packs.find((item) => this.packData(item).packCount === 1) || this.packs[0] || this;
      }

      parseVariantMap(el) {
        if (!el?.dataset.variantData) return null;
        try {
          return JSON.parse(el.dataset.variantData);
        } catch (error) {
          return null;
        }
      }

      variantEntry(variantData, packCount) {
        if (!variantData) return null;
        const key = String(Math.max(packCount, 1));
        return variantData[key] || variantData[packCount] || variantData['1'] || variantData[1] || null;
      }

      normalizeImageUrl(url) {
        const trimmed = String(url || '').trim();
        if (!trimmed) return '';
        if (trimmed.startsWith('//')) return `${window.location.protocol}${trimmed}`;
        return trimmed;
      }

      updateItemImage(el, selector, variantData, packCount) {
        const img = el.querySelector(selector);
        if (!img) return;

        const entry = this.variantEntry(variantData, packCount);
        const src = this.normalizeImageUrl(entry?.image);
        if (!src || img.src === src) return;

        img.src = src;
        img.removeAttribute('srcset');
      }

      getClassicFrequencyData() {
        const option = this.frequencySelect?.selectedOptions?.[0];
        if (!option) return null;
        const data = {
          id: option.dataset.variantId || '',
          sellingPlan: option.dataset.sellingPlan || option.value || '',
          packCount: parseInt(option.dataset.packCount, 10) || 1,
          price: parseInt(option.dataset.packPrice, 10) || 0,
          variantPrice: parseInt(option.dataset.packPrice, 10) || 0,
          subPrice: parseInt(option.dataset.packSubPrice, 10) || 0,
          comparePrice: parseInt(option.dataset.packComparePrice, 10) || 0,
          discountType: (option.dataset.discountType || '').toLowerCase(),
          discountValue: parseFloat(option.dataset.discountValue || '0') || 0,
          available: option.dataset.available !== 'false',
        };
        data.sellingPlan = this.resolveMainSellingPlan(data);
        return data;
      }

      activePackData() {
        if (this.dataset.layout === 'classic') {
          const freq = this.getClassicFrequencyData();
          if (freq?.id) return freq;
        }
        return this.packData(this.selectedPack());
      }

      classicSubscriptionVariantId() {
        return this.getClassicFrequencyData()?.id || this.dataset.variantId || this.dataset.selectedId || '';
      }

      getMainCartItem() {
        const pack = this.activePackData();
        const quantity = this.mainQuantity();
        const subSelected = this.getActiveMode() === 'sub';
        const variantId =
          this.dataset.layout === 'classic'
            ? pack.id || this.classicSubscriptionVariantId()
            : pack.id;

        return {
          id: variantId,
          quantity,
          sellingPlan: subSelected ? this.resolveMainSellingPlan(pack) : '',
        };
      }

      getActiveMode() {
        return this.querySelector('.price-plan__mode-input:checked')?.value || this.mode || 'sub';
      }

      isSubMode() {
        return this.getActiveMode() === 'sub';
      }

      isD3Gift(el) {
        const label = `${el?.dataset?.giftHandle || ''} ${el?.dataset?.addonHandle || ''} ${el?.dataset?.name || ''}`.toLowerCase();
        return label.includes('d3') || label.includes('vitamin');
      }

      isOmegaGift(el) {
        if (el?.dataset?.omegaGift === 'true') return true;
        const label = `${el?.dataset?.giftHandle || ''} ${el?.dataset?.addonHandle || ''} ${el?.dataset?.name || ''}`.toLowerCase();
        return label.includes('omega');
      }

      kwfmFrauMannAddonVariant(packCount, giftType) {
        const months = Math.max(parseInt(packCount, 10) || 1, 1);
        if (giftType === 'omega') {
          const entry = this.resolveKwfmFrauMannOmegaGift(months);
          return entry?.id ? String(entry.id) : '';
        }
        const entry = this.resolveKwfmFrauMannD3Gift(months);
        return entry?.id ? String(entry.id) : '';
      }

      kwfmFrauMannAddonType(el) {
        if (!el?.hasAttribute('data-addon')) return '';
        const label = `${el?.dataset?.addonHandle || ''} ${el?.dataset?.name || ''}`.toLowerCase();
        if (label.includes('omega')) return 'omega';
        if (label.includes('d3') || label.includes('vitamin') || el?.dataset?.noteMode === 'months') {
          return 'd3';
        }
        return '';
      }

      kwfmFrauMannAddonLine(el, packCount) {
        if (!this.isKinderwunschFrauMann() || !el?.hasAttribute('data-addon')) {
          return null;
        }

        const addonType = this.kwfmFrauMannAddonType(el);
        if (!addonType) return null;

        const variantId = this.kwfmFrauMannAddonVariant(packCount, addonType);
        if (!variantId) return null;

        return {
          id: variantId,
          quantity: 1,
          sellingPlan: '',
        };
      }

      kwfmFrauMannOnceAddonCartLines(packCount) {
        if (!this.isKinderwunschFrauMann() || this.getActiveMode() !== 'once') return [];

        const lines = [];
        this.addons.forEach((addon) => {
          if (!this.addonQty(addon)) return;
          const item = this.kwfmFrauMannAddonLine(addon, packCount);
          if (!item?.id) return;
          lines.push({
            id: parseInt(item.id, 10),
            quantity: 1,
          });
        });

        return lines;
      }

      productHandle() {
        return String(this.dataset.productHandle || '').toLowerCase();
      }

      isStandaloneMainProduct() {
        return STANDALONE_MAIN_PRODUCT_HANDLES.has(this.productHandle());
      }

      isOmegaMainProduct() {
        return this.productHandle() === 'omega-3';
      }

      isD3MainProduct() {
        return this.productHandle() === 'vitamin-d3-k2-oel';
      }

      isBlockedMainProductPlan(planId, pack) {
        const id = String(planId || '').trim();
        if (!id) return true;
        if (OMEGA_FREE_MAIN_PLAN_IDS.has(id)) return true;

        if (!pack) return false;

        const type = (pack.discountType || '').toLowerCase();
        const value = parseFloat(pack.discountValue || '0') || 0;
        const listPrice = parseInt(pack.price, 10) || 0;
        const subPrice = parseInt(pack.subPrice, 10) || 0;

        if (type === 'percentage' && value >= 100) return true;
        if (type === 'price' && value === 0 && listPrice > 0) return true;
        if (listPrice > 0 && subPrice === 0 && type === 'percentage' && value >= 100) return true;

        return false;
      }

      sanitizeMainSellingPlan(planId, pack) {
        if (!this.isStandaloneMainProduct()) return String(planId || '');
        if (!this.isBlockedMainProductPlan(planId, pack)) return String(planId || '');
        return '';
      }

      findMainSellingPlanFromFrequencySelect() {
        const option = this.frequencySelect?.selectedOptions?.[0];
        if (!option) return '';

        for (const opt of Array.from(this.frequencySelect.options)) {
          const candidate = {
            sellingPlan: opt.dataset.sellingPlan || opt.value || '',
            discountType: (opt.dataset.discountType || '').toLowerCase(),
            discountValue: parseFloat(opt.dataset.discountValue || '0') || 0,
            price: parseInt(opt.dataset.packPrice, 10) || 0,
            subPrice: parseInt(opt.dataset.packSubPrice, 10) || 0,
          };
          const plan = this.sanitizeMainSellingPlan(candidate.sellingPlan, candidate);
          if (plan) return plan;
        }

        return '';
      }

      findMainSellingPlanFromPacks(packCount) {
        const months = Math.max(parseInt(packCount, 10) || 1, 1);
        const matching = this.packs.filter(
          (packEl) => parseInt(packEl.dataset.packCount, 10) === months
        );
        const candidates = matching.length ? matching : this.packs;

        for (const packEl of candidates) {
          const raw = {
            sellingPlan: packEl.dataset.sellingPlan || '',
            discountType: (packEl.dataset.discountType || '').toLowerCase(),
            discountValue: parseFloat(packEl.dataset.discountValue || '0') || 0,
            price: parseInt(packEl.dataset.packPrice, 10) || 0,
            subPrice: parseInt(packEl.dataset.packSubPrice, 10) || 0,
          };
          const plan = this.sanitizeMainSellingPlan(raw.sellingPlan, raw);
          if (plan) return plan;
        }

        return '';
      }

      resolveMainSellingPlan(pack) {
        if (!this.isStandaloneMainProduct()) {
          return pack?.sellingPlan || this.dataset.sellingPlan || '';
        }

        let plan = this.sanitizeMainSellingPlan(
          pack?.sellingPlan || this.dataset.sellingPlan || '',
          pack
        );
        if (!plan && this.dataset.layout === 'classic') {
          plan = this.findMainSellingPlanFromFrequencySelect();
        }
        if (!plan) {
          plan = this.findMainSellingPlanFromPacks(pack?.packCount);
        }
        return plan;
      }

      isKinderwunschBundle() {
        if (this.dataset.giftQtyProfile === 'kwfm-bundle') return true;

        const handle = this.productHandle();
        if (handle === 'kinderwunsch-bundle') return true;

        const path = window.location?.pathname || '';
        return path.includes('kinderwunsch-bundle');
      }

      isPhasenBundle() {
        if (this.dataset.giftQtyProfile === 'phasen-bundle') return true;
        return OMEGA_PHASEN_PRODUCT_HANDLES.has(this.productHandle());
      }

      isKinderwunschFrauMann() {
        if (this.dataset.kwfmFrauMannGifts === 'true') return true;

        const handle = this.productHandle();
        if (KWFM_FRAU_MANN_PRODUCT_HANDLES.has(handle)) return true;

        const path = (window.location?.pathname || '').toLowerCase();
        return path.includes('kinderwunsch-bundle');
      }

      kwfmFrauMannGiftLine(el, packCount) {
        if (!this.isKinderwunschFrauMann() || !this.isSubMode() || !el?.hasAttribute('data-gift')) {
          return null;
        }

        const months = Math.max(parseInt(packCount, 10) || 1, 1);

        if (this.isOmegaGift(el)) {
          const omega = this.resolveKwfmFrauMannOmegaGift(months);
          if (omega?.id && omega?.sellingPlan) {
            return {
              id: String(omega.id),
              quantity: 1,
              sellingPlan: String(omega.sellingPlan),
            };
          }
        }

        if (this.isD3Gift(el) || el?.dataset?.noteMode === 'months') {
          const d3 = this.resolveKwfmFrauMannD3Gift(months);
          if (d3?.id && d3?.sellingPlan) {
            return {
              id: String(d3.id),
              quantity: 1,
              sellingPlan: String(d3.sellingPlan),
            };
          }
        }

        return null;
      }

      resolveKwfmFrauMannOmegaGift(packCount) {
        const months = Math.max(parseInt(packCount, 10) || 1, 1);
        const fromConfig =
          this.kwfmCartConfig?.omega?.[String(months)] || this.kwfmCartConfig?.omega?.[months];
        if (fromConfig?.id && fromConfig?.sellingPlan) {
          return {
            id: String(fromConfig.id),
            sellingPlan: String(fromConfig.sellingPlan),
          };
        }
        const entry = KWFM_FRAU_MANN_OMEGA_BY_PACK[months] || KWFM_FRAU_MANN_OMEGA_BY_PACK[1];
        return entry
          ? {
              id: String(entry.id),
              sellingPlan: String(entry.sellingPlan),
            }
          : null;
      }

      resolveKwfmFrauMannD3Gift(packCount) {
        const months = Math.max(parseInt(packCount, 10) || 1, 1);
        const fromConfig =
          this.kwfmCartConfig?.d3?.[String(months)] || this.kwfmCartConfig?.d3?.[months];
        if (fromConfig?.id && fromConfig?.sellingPlan) {
          return {
            id: String(fromConfig.id),
            sellingPlan: String(fromConfig.sellingPlan),
          };
        }
        const entry = KWFM_FRAU_MANN_D3_BY_PACK[months] || KWFM_FRAU_MANN_D3_BY_PACK[1];
        return entry
          ? {
              id: String(entry.id),
              sellingPlan: String(entry.sellingPlan),
            }
          : null;
      }

      kwfmFrauMannSubGiftCartLines(packCount, groupId) {
        if (!this.isKinderwunschFrauMann() || !this.isSubMode()) return [];

        const months = Math.max(parseInt(packCount, 10) || 1, 1);
        const lines = [];

        const omega = this.resolveKwfmFrauMannOmegaGift(months);
        if (omega?.id && omega?.sellingPlan) {
          lines.push({
            id: parseInt(omega.id, 10),
            quantity: 1,
            selling_plan: parseInt(omega.sellingPlan, 10),
            properties: this.kwfmGiftCartProperties('omega', months, groupId),
          });
        }

        const d3 = this.resolveKwfmFrauMannD3Gift(months);
        if (d3?.id && d3?.sellingPlan) {
          lines.push({
            id: parseInt(d3.id, 10),
            quantity: 1,
            selling_plan: parseInt(d3.sellingPlan, 10),
            properties: this.kwfmGiftCartProperties('d3', months, groupId),
          });
        }

        return lines;
      }

      kwfmGiftCartProperties(giftType, packCount, groupId) {
        const props = { 'Gratis dazu': 'Sparplan' };
        if (groupId) props._sparplan_group = groupId;
        props._gift_pack_months = giftType === 'omega' ? String(packCount) : '11';
        return props;
      }

      usesPhasenOmegaGiftPlans() {
        return this.isPhasenBundle();
      }

      giftQtyProfile() {
        if (this.isKinderwunschBundle()) {
          return {
            omegaMultiplier: KINDERWUNSCH_BUNDLE_GIFT_MULTIPLIER,
            giftMultiplier: KINDERWUNSCH_BUNDLE_GIFT_MULTIPLIER,
            omegaScalePack: true,
          };
        }
        if (this.usesPhasenOmegaGiftPlans()) {
          return {
            omegaMultiplier: 1,
            giftMultiplier: 1,
            omegaScalePack: false,
          };
        }
        return null;
      }

      isOmegaAddon(el) {
        return el?.hasAttribute('data-addon') && this.isOmegaGift(el);
      }

      usesPhasenFreeAddonPlans() {
        return this.isPhasenBundle();
      }

      usesSubscriptionOmegaGiftPlans() {
        return this.isKinderwunschBundle() || this.usesPhasenOmegaGiftPlans();
      }

      resolveSubscriptionOmegaGift(packCount) {
        if (this.isKinderwunschFrauMann()) {
          return this.resolveKwfmFrauMannOmegaGift(packCount);
        }

        const months = Math.max(parseInt(packCount, 10) || 1, 1);
        const map = this.isPhasenBundle() ? OMEGA_PHASEN_GIFT_BY_PACK : OMEGA_KWFM_GIFT_BY_PACK;
        const entry = map[months] || map[1];
        return entry
          ? {
              id: String(entry.id),
              sellingPlan: String(entry.sellingPlan),
            }
          : null;
      }

      parseBundlePlans(el) {
        if (!el?.dataset?.bundlePlans) return null;
        try {
          return JSON.parse(el.dataset.bundlePlans);
        } catch (error) {
          return null;
        }
      }

      strictVariantEntry(variantData, packCount) {
        if (!variantData) return null;
        const key = String(Math.max(parseInt(packCount, 10) || 1, 1));
        return variantData[key] || variantData[packCount] || null;
      }

      usesFixedOmegaGiftPlans() {
        return this.isKinderwunschBundle();
      }

      resolveOmegaGiftItem(packCount) {
        return this.resolveSubscriptionOmegaGift(packCount);
      }

      giftQuantity(el, packCount) {
        const baseQty = this.mainQuantity();
        const months = Math.max(parseInt(packCount, 10) || 1, 1);

        if (this.isKinderwunschFrauMann() && this.isSubMode() && el?.hasAttribute('data-gift')) {
          return 1;
        }

        if (
          this.isOmegaGift(el) &&
          this.isPhasenBundle() &&
          this.isSubMode() &&
          this.bundleGiftEntry(el, packCount)?.id
        ) {
          return baseQty;
        }

        const profile = this.giftQtyProfile();

        if (profile) {
          if (this.isOmegaGift(el)) {
            return profile.omegaScalePack
              ? months * profile.omegaMultiplier * baseQty
              : profile.omegaMultiplier * baseQty;
          }
          return profile.giftMultiplier * baseQty;
        }

        const fromData = parseInt(el?.dataset?.giftQtyMultiplier, 10);
        const multiplier = Number.isFinite(fromData) && fromData > 0 ? fromData : 1;
        const scalePack =
          el?.dataset?.giftQtyScalePack === 'true' ||
          (el?.dataset?.qtyMode === 'pack' && this.isOmegaGift(el));

        if (scalePack && this.isOmegaGift(el)) {
          if (this.isPhasenBundle() && !this.giftQtyProfile()?.omegaScalePack) {
            return multiplier * baseQty;
          }
          return months * multiplier * baseQty;
        }

        return multiplier * baseQty;
      }

      bundleGiftEntry(el, packCount) {
        if (el?.dataset?.qtyMode !== 'pack' || !this.isOmegaGift(el) || !this.isSubMode()) {
          return null;
        }

        const months = Math.max(parseInt(packCount, 10) || 1, 1);

        if (this.isKinderwunschFrauMann()) {
          return this.resolveKwfmFrauMannOmegaGift(months);
        }

        if (this.usesSubscriptionOmegaGiftPlans()) {
          const resolved = this.resolveSubscriptionOmegaGift(months);
          if (resolved?.id && resolved?.sellingPlan) {
            return resolved;
          }

          const bundlePlans = this.parseBundlePlans(el);
          const fromPlans = bundlePlans?.[String(months)] || bundlePlans?.[months];
          if (fromPlans?.id && fromPlans?.sellingPlan) {
            return {
              id: String(fromPlans.id),
              sellingPlan: String(fromPlans.sellingPlan),
            };
          }
        }

        const variantData = this.parseVariantMap(el);
        const packEntry = this.strictVariantEntry(variantData, months);
        if (packEntry?.id && packEntry?.sellingPlan) {
          return {
            id: String(packEntry.id),
            sellingPlan: String(packEntry.sellingPlan),
          };
        }

        return null;
      }

      giftSellingPlan(el, packVariant, packCount) {
        if (!this.isSubMode()) return '';

        if (this.isKinderwunschFrauMann() && this.isD3Gift(el)) {
          const d3 = this.resolveKwfmFrauMannD3Gift(packCount);
          if (d3?.sellingPlan) return d3.sellingPlan;
        }

        const bundle = this.bundleGiftEntry(el, packCount);
        if (bundle?.sellingPlan) return bundle.sellingPlan;

        if (this.isOmegaGift(el) && el.dataset.qtyMode === 'pack' && this.usesSubscriptionOmegaGiftPlans()) {
          const paid = this.resolveSubscriptionOmegaGift(packCount);
          if (paid?.sellingPlan) return paid.sellingPlan;
        }

        if (packVariant?.sellingPlan && this.isOmegaGift(el)) {
          return String(packVariant.sellingPlan);
        }

        if (el.dataset.noteMode === 'months') {
          return String(el.dataset.giftSellingPlan || D3_BUNDLE_SELLING_PLAN);
        }
        return '';
      }

      giftVariantId(el, packVariant, unitId, packCount) {
        if (!this.isSubMode()) {
          if (el.dataset.qtyMode === 'pack') {
            return String(packVariant?.id || unitId);
          }
          return String(el.dataset.subscriptionVariantId || el.dataset.variantId || unitId);
        }

        if (this.isKinderwunschFrauMann() && this.isD3Gift(el)) {
          const d3 = this.resolveKwfmFrauMannD3Gift(packCount);
          if (d3?.id) return d3.id;
        }

        const bundle = this.bundleGiftEntry(el, packCount);
        if (bundle?.id) return bundle.id;

        if (el.dataset.noteMode === 'months') {
          return String(el.dataset.subscriptionVariantId || el.dataset.variantId || unitId);
        }

        if (el.dataset.qtyMode === 'pack') {
          return String(packVariant?.id || unitId);
        }
        return String(el.dataset.subscriptionVariantId || el.dataset.variantId || unitId);
      }

      addonCartItem(el, packCount) {
        if (!el?.hasAttribute('data-addon')) return null;

        const quantity = this.addonQty(el);
        if (!quantity) return null;

        const kwfmAddon = this.kwfmFrauMannAddonLine(el, packCount);
        if (kwfmAddon?.id) {
          return kwfmAddon;
        }

        if (!el?.dataset.variantId) return null;

        const months = Math.max(parseInt(packCount, 10) || 1, 1);
        const baseQty = this.mainQuantity();
        const phasenOmega = this.isOmegaAddon(el) && this.isPhasenBundle();

        if (phasenOmega && this.usesPhasenFreeAddonPlans() && !this.isKinderwunschFrauMann()) {
          const entry = OMEGA_PHASEN_FREE_BY_PACK[months] || OMEGA_PHASEN_FREE_BY_PACK[1];
          if (entry?.id && entry?.sellingPlan) {
            return {
              id: String(entry.id),
              quantity: 1,
              sellingPlan: String(entry.sellingPlan),
            };
          }
        }

        const variantData = this.parseVariantMap(el);
        const unitVariant = variantData?.[1] || variantData?.['1'];
        const unitId = String(unitVariant?.id || el.dataset.variantId);
        const packVariant = this.variantEntry(variantData, packCount);

        let variantId;
        let lineQty;

        if (el.dataset.qtyMode === 'pack') {
          variantId = String(packVariant?.id || unitId);
          if (phasenOmega) {
            lineQty = 1;
          } else if (this.isOmegaAddon(el) && variantId === unitId) {
            lineQty = months * baseQty;
          } else {
            lineQty = quantity;
          }
        } else {
          variantId = String(el.dataset.variantId || unitId);
          lineQty = phasenOmega ? 1 : quantity;
        }

        if (!variantId) return null;

        if (
          this.isKinderwunschFrauMann() &&
          (LEGACY_OMEGA_VARIANT_IDS.has(String(variantId)) ||
            LEGACY_D3_VARIANT_IDS.has(String(variantId)))
        ) {
          return null;
        }

        return {
          id: variantId,
          quantity: lineQty,
          sellingPlan: '',
        };
      }

      sparplanGroupId() {
        return `sp${Date.now().toString(36)}${Math.random().toString(36).slice(2, 8)}`;
      }

      mainSparplanProperties(groupId) {
        if (!groupId) return undefined;
        return {
          _sparplan_group: groupId,
          _sparplan_primary: '1',
        };
      }

      giftCartProperties(el, packCount, groupId) {
        const props = { 'Gratis dazu': 'Sparplan' };
        const months = Math.max(parseInt(packCount, 10) || 1, 1);

        if (groupId) {
          props._sparplan_group = groupId;
        }

        if (this.isOmegaGift(el)) {
          props._gift_pack_months = String(months);
        } else if (this.isD3Gift(el) || el?.dataset?.noteMode === 'months') {
          props._gift_pack_months = '11';
        }

        return props;
      }

      giftCartItem(el, packCount) {
        if (!el?.hasAttribute('data-gift') || !this.isSubMode()) return null;

        const kwfmGift = this.kwfmFrauMannGiftLine(el, packCount);
        if (kwfmGift?.id && kwfmGift?.sellingPlan) {
          return kwfmGift;
        }

        if (!el?.dataset.variantId) return null;

        const variantData = this.parseVariantMap(el);
        const unitVariant = variantData?.[1] || variantData?.['1'];
        const unitId = String(
          unitVariant?.id || el.dataset.originalVariantId || el.dataset.variantId
        );
        const packVariant = this.variantEntry(variantData, packCount);
        const sellingPlan = this.giftSellingPlan(el, packVariant, packCount);
        let variantId = this.giftVariantId(el, packVariant, unitId, packCount);

        if (
          this.isKinderwunschFrauMann() &&
          (LEGACY_OMEGA_VARIANT_IDS.has(String(variantId)) ||
            LEGACY_D3_VARIANT_IDS.has(String(variantId)))
        ) {
          return null;
        }

        if (!variantId || !sellingPlan) return null;

        return {
          id: variantId,
          quantity: this.giftQuantity(el, packCount),
          sellingPlan,
        };
      }

      extraCartItem(el, packCount) {
        if (!el?.dataset.variantId) return null;

        const mode = this.getActiveMode();
        if (mode === 'sub' && el.hasAttribute('data-gift')) {
          return this.giftCartItem(el, packCount);
        }
        if (mode === 'once' && el.hasAttribute('data-addon')) {
          return this.addonCartItem(el, packCount);
        }
        return null;
      }

      giftQty(el, packCount) {
        return this.extraCartItem(el, packCount)?.quantity || 0;
      }

      portionsText(packCount) {
        if (packCount > 1) {
          return (this.strings.portions || '__COUNT__x __SERVINGS__ Tagesportionen')
            .replace('__COUNT__', String(packCount))
            .replace('__SERVINGS__', String(this.servings));
        }
        return (this.strings.portionsOne || '__SERVINGS__ Tagesportionen').replace(
          '__SERVINGS__',
          String(this.servings)
        );
      }

      isMonthsNote(note, mode) {
        if (mode === 'months') return true;
        return /monat|month|reicht|__COUNT__/i.test(note || '');
      }

      durationMonths(el, note) {
        const fromData = parseInt(el?.dataset.lastsMonths, 10);
        if (fromData > 0) return fromData;
        const match = String(note || '').match(/(\d+)/);
        if (match) return parseInt(match[1], 10);
        return 11;
      }

      durationNote(el, note) {
        if (note && !note.includes('__COUNT__')) return note;
        const months = this.durationMonths(el, note);
        if (note && note.includes('__COUNT__')) {
          return note.split('__COUNT__').join(String(months));
        }
        return (this.strings.giftLastsOther || 'reicht für __COUNT__ Monate').replace(
          '__COUNT__',
          String(months)
        );
      }

      isBundleOmegaGiftDisplay(el) {
        return this.isKinderwunschFrauMann() && this.isSubMode() && this.isOmegaGift(el);
      }

      isPhasenOmegaGiftDisplay(el) {
        return this.isPhasenBundle() && this.isSubMode() && this.isOmegaGift(el);
      }

      phasenOmegaDisplayCount(packCount) {
        return Math.max(parseInt(packCount, 10) || 1, 1);
      }

      bundleOmegaGiftDisplayQty(packCount) {
        return Math.max(parseInt(packCount, 10) || 1, 1) * 2;
      }

      bundleOmegaAddonPortionsCount(packCount) {
        return this.bundleOmegaGiftDisplayQty(packCount);
      }

      kwfmOmegaBundleValuePrice(packPriceCents) {
        return (parseInt(packPriceCents, 10) || 0) * 2;
      }

      kwfmD3DisplayName(baseName) {
        return this.formatManyProductName(2, baseName);
      }

      isKwfmD3Gift(el) {
        return (
          this.isKinderwunschFrauMann() &&
          el?.hasAttribute('data-gift') &&
          this.isD3Gift(el)
        );
      }

      isKwfmD3Item(el) {
        return (
          this.isKinderwunschFrauMann() &&
          (this.isD3Gift(el) || el?.dataset?.noteMode === 'months')
        );
      }

      isKwfmOmegaAddon(addon) {
        return this.isKinderwunschFrauMann() && this.isOmegaAddon(addon);
      }

      isPhasenOmegaAddon(addon) {
        return this.isPhasenBundle() && this.isOmegaAddon(addon);
      }

      isKwfmD3Addon(addon) {
        return addon?.hasAttribute('data-addon') && this.isKwfmD3Item(addon);
      }

      formatManyProductName(count, baseName) {
        return (this.strings.giftNameMany || '__COUNT__x __NAME__')
          .replace('__COUNT__', String(count))
          .replace('__NAME__', baseName);
      }

      updateGiftCopy(gift, packCount) {
        const nameEl = gift.querySelector('[data-gift-name]');
        const noteEl = gift.querySelector('[data-gift-note]');
        const baseName = gift.dataset.name || nameEl?.textContent || '';

        let variantData = null;
        if (gift.dataset.variantData) {
          try {
            variantData = JSON.parse(gift.dataset.variantData);
          } catch (e) {
            console.error("Error parsing variant data JSON", e);
          }
        }

        if (!gift.dataset.originalVariantId) {
          gift.dataset.originalVariantId = gift.dataset.variantId || '';
        }

        const months = Math.max(packCount, 1);
        const unitPrice = parseInt(
          variantData?.[1]?.price || variantData?.['1']?.price || gift.dataset.price,
          10
        ) || 0;
        const unitId = String(
          variantData?.[1]?.id || variantData?.['1']?.id || gift.dataset.originalVariantId
        );
        const packEntry = this.variantEntry(variantData, packCount);
        const subSelected = this.isSubMode();
        const cartVariantId = subSelected
          ? this.giftVariantId(gift, packEntry, unitId, packCount)
          : String(packEntry?.id || gift.dataset.variantId || unitId);
        gift.setAttribute('data-variant-id', cartVariantId);

        if (subSelected) {
          const sellingPlan = this.giftSellingPlan(gift, packEntry, packCount);
          if (sellingPlan) {
            gift.setAttribute('data-selling-plan', sellingPlan);
          } else {
            gift.removeAttribute('data-selling-plan');
          }
        } else {
          gift.removeAttribute('data-selling-plan');
        }

        const extra = gift.dataset.note;
        const monthsNote = this.isMonthsNote(extra, gift.dataset.noteMode);
        const lineQty = this.giftQuantity(gift, packCount);
        const bundleOmegaDisplay = this.isBundleOmegaGiftDisplay(gift);
        const phasenOmegaDisplay = this.isPhasenOmegaGiftDisplay(gift);
        const scaledOmegaDisplay = bundleOmegaDisplay || phasenOmegaDisplay;
        const displayQty = bundleOmegaDisplay
          ? this.bundleOmegaGiftDisplayQty(packCount)
          : phasenOmegaDisplay
            ? this.phasenOmegaDisplayCount(packCount)
            : lineQty;
        const valueQty = scaledOmegaDisplay ? displayQty : lineQty;
        const packPrice = parseInt(packEntry?.price || gift.dataset.price, 10) || unitPrice;
        const price = unitPrice;

        if (nameEl) {
          if (this.isKwfmD3Gift(gift)) {
            nameEl.textContent = this.kwfmD3DisplayName(baseName);
          } else {
            nameEl.textContent =
              displayQty > 1
                ? (this.strings.giftNameMany || '__COUNT__x __NAME__')
                    .replace('__COUNT__', String(displayQty))
                    .replace('__NAME__', baseName)
                : baseName;
          }
        }

        if (noteEl) {
          const amount = scaledOmegaDisplay
            ? this.formatMoney(
                bundleOmegaDisplay
                  ? this.kwfmOmegaBundleValuePrice(packPrice)
                  : packPrice
              )
            : this.formatMoney(price * valueQty);
          if (scaledOmegaDisplay) {
            noteEl.textContent = (this.strings.giftValuePortions || 'Wert __AMOUNT__ · __PORTIONS__')
              .replace('__AMOUNT__', amount)
              .replace('__PORTIONS__', this.portionsText(displayQty));
          } else if (lineQty > 1) {
            const portions = monthsNote
              ? this.durationNote(gift, extra)
              : this.portionsText(months);
            noteEl.textContent = (this.strings.giftValuePortions || 'Wert __AMOUNT__ · __PORTIONS__')
              .replace('__AMOUNT__', amount)
              .replace('__PORTIONS__', portions);
          } else if (gift.dataset.qtyMode === 'pack') {
            noteEl.textContent = (this.strings.giftValuePortions || 'Wert __AMOUNT__ · __PORTIONS__')
              .replace('__AMOUNT__', amount)
              .replace('__PORTIONS__', this.portionsText(months));
          } else if (monthsNote) {
            noteEl.textContent = (this.strings.giftValuePortions || 'Wert __AMOUNT__ · __PORTIONS__')
              .replace('__AMOUNT__', amount)
              .replace('__PORTIONS__', this.durationNote(gift, extra));
          } else if (extra) {
            noteEl.textContent = (this.strings.giftValuePortions || 'Wert __AMOUNT__ · __PORTIONS__')
              .replace('__AMOUNT__', amount)
              .replace('__PORTIONS__', extra);
          } else {
            noteEl.textContent = (this.strings.giftValue || 'Wert __AMOUNT__').replace(
              '__AMOUNT__',
              amount
            );
          }
        }
        this.updateItemImage(gift, '[data-gift-image]', variantData, packCount);
      }

      extraQty(el, packCount) {
        return this.giftQty(el, packCount);
      }

      cartSortOrder(el) {
        const fromData = parseInt(el?.dataset?.cartSort, 10);
        if (fromData > 0) return fromData;
        const label = `${el?.dataset?.name || ''} ${el?.textContent || ''}`.toLowerCase();
        if (label.includes('omega')) return 2;
        if (label.includes('d3') || label.includes('vitamin d')) return 3;
        return 50;
      }

      sortCartExtras(entries) {
        return entries
          .slice()
          .sort((a, b) => this.cartSortOrder(a.el) - this.cartSortOrder(b.el))
          .map((entry) => entry.item);
      }

      getSelectedPackCount() {
        const pack = this.selectedPack();
        return this.packData(pack).packCount || 1;
      }

      buildCartItems() {
        const mode = this.getActiveMode();
        const packCount = this.getSelectedPackCount();
        const main = this.getMainCartItem();
        const mainId = String(main.id || '');
        const items = [];
        const groupId =
          mode === 'sub' && (this.gifts.length > 0 || this.isKinderwunschFrauMann())
            ? this.sparplanGroupId()
            : '';

        if (mainId) {
          const mainItem = {
            id: parseInt(mainId, 10),
            quantity: parseInt(main.quantity, 10) || 1,
            selling_plan: main.sellingPlan ? parseInt(main.sellingPlan, 10) : undefined,
          };
          const mainProps = this.mainSparplanProperties(groupId);
          if (mainProps) mainItem.properties = mainProps;
          items.push(mainItem);
        }

        if (mode === 'sub') {
          if (this.isKinderwunschFrauMann()) {
            this.kwfmFrauMannSubGiftCartLines(packCount, groupId).forEach((line) => items.push(line));
          } else {
            this.sortCartExtras(
              this.gifts
                .map((gift) => {
                  const item = this.extraCartItem(gift, packCount);
                  if (!item?.id || String(item.id) === mainId) return null;
                  return {
                    el: gift,
                    item: {
                      id: parseInt(item.id, 10),
                      quantity: parseInt(item.quantity, 10) || 1,
                      selling_plan: parseInt(item.sellingPlan, 10),
                      properties: this.giftCartProperties(gift, packCount, groupId),
                    },
                  };
                })
                .filter(Boolean)
            ).forEach((item) => items.push(item));
          }
        } else if (this.isKinderwunschFrauMann()) {
          this.kwfmFrauMannOnceAddonCartLines(packCount).forEach((line) => items.push(line));
        } else {
          this.addons.forEach((addon) => {
            if (!this.addonQty(addon)) return;
            const item = this.extraCartItem(addon, packCount);
            if (!item?.id || String(item.id) === mainId) return;
            const line = {
              id: parseInt(item.id, 10),
              quantity: parseInt(item.quantity, 10) || 1,
            };
            if (item.sellingPlan) {
              line.selling_plan = parseInt(item.sellingPlan, 10);
            }
            items.push(line);
          });
        }

        return items.slice().reverse();
      }

      getAdditionalItems() {
        const packCount = this.getSelectedPackCount();
        const main = this.getMainCartItem();
        const mainId = String(main.id || '');

        if (this.getActiveMode() === 'sub') {
          const groupId = this.gifts.length > 0 || this.isKinderwunschFrauMann()
            ? this.sparplanGroupId()
            : '';
          this._pendingSparplanGroupId = groupId;

          if (this.isKinderwunschFrauMann()) {
            return this.kwfmFrauMannSubGiftCartLines(packCount, groupId).map((item) => ({
              id: String(item.id),
              quantity: item.quantity,
              sellingPlan: String(item.selling_plan),
              properties: item.properties,
            }));
          }

          const entries = this.gifts
            .map((gift) => {
              const item = this.extraCartItem(gift, packCount);
              if (!item?.id || item.id === mainId) return null;
              return {
                el: gift,
                item: {
                  ...item,
                  properties: this.giftCartProperties(gift, packCount, groupId),
                },
              };
            })
            .filter(Boolean);
          return this.sortCartExtras(entries);
        }

        this._pendingSparplanGroupId = '';

        if (this.isKinderwunschFrauMann()) {
          return this.kwfmFrauMannOnceAddonCartLines(packCount).map((item) => ({
            id: String(item.id),
            quantity: item.quantity,
            sellingPlan: '',
          }));
        }

        const entries = this.addons
          .map((addon) => {
            if (!this.addonQty(addon)) return null;
            const item = this.extraCartItem(addon, packCount);
            if (!item?.id || item.id === mainId) return null;
            return { el: addon, item };
          })
          .filter(Boolean);
        return this.sortCartExtras(entries);
      }
    }
  );
}
